module.exports = __webpack_public_path__ + "static/media/Logo.49e3fe08.png";